import {
  Box,
  Container,
  Grid,
  Image,
  List,
  Text,
  ThemeIcon,
  Title,
} from '@mantine/core';
import { Helmet } from 'react-helmet';
import { CircleCheck } from 'tabler-icons-react';
import Logos from '../../components/logos/logos.component';
import RegisterForm from '../../components/register-form/register-form.component';
import '../../components/register-form/register-form.styles.css';

interface ImageProps {
  source: string;
}

function RegisterPage() {
  return (
    <>
      <Helmet>
        <title>XPAY.World - Register</title>
      </Helmet>
      <Container fluid style={{ maxWidth: 1200 }}>
        <Grid
          sx={{
            minHeight: '100vh',
          }}
          py={30}
        >
          <Grid.Col
            md={6}
            sx={{
              paddingLeft: '10%',
              paddingTop: '15%',
            }}
          >
            <Image
              src='/images/xpay-dark.png'
              alt='xpay.world logo'
              width={80}
              mb={40}
            />
            <Title order={2} mb={40}>
              Manage your payments with XPay
            </Title>
            <List
              spacing='xl'
              size='sm'
              center
              icon={
                <ThemeIcon color='teal' size={24} radius='xl'>
                  <CircleCheck size={16} />
                </ThemeIcon>
              }
              sx={{ maxWidth: '400px' }}
            >
              <List.Item>
                <Text weight={600}> One platform to accept payments</Text>
              </List.Item>
              <List.Item>
                <Text weight={600}>
                  Receive all payments in your account of choice
                </Text>
              </List.Item>
              <List.Item>
                <Text weight={600}>
                  Accept major payment methods available in the Philippines
                </Text>
              </List.Item>
            </List>
            <Logos />
          </Grid.Col>
          <Grid.Col
            md={6}
            sm={12}
            sx={{
              minHeight: '100%',
              display: 'table',
              width: '100%',
            }}
          >
            <Box sx={{ display: 'table-cell', verticalAlign: 'middle' }}>
              <RegisterForm />
            </Box>
          </Grid.Col>
        </Grid>
      </Container>
    </>
  );
}

export default RegisterPage;
